// extracted by mini-css-extract-plugin
export default {"radio":"JcA0b7vM4poRdU7xDj2C","heading":"lYzfYsV71JpDNH_mXCNZ","labelTextContainer":"XuDU_5VamJ7V5DYtcNXw"};